import { render, staticRenderFns } from "./BaseResourceFormDialog.vue?vue&type=template&id=4cbe73f3"
import script from "./BaseResourceFormDialog.vue?vue&type=script&lang=ts"
export * from "./BaseResourceFormDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports